import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiciosService } from './servicios.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  controlTiempo = false;
  user: any;
  constructor(public router: Router, private ser: ServiciosService) { }


  public userProfile: any;

  // auth0 = new auth0.WebAuth({
  //   clientID: '4H5gt8Zn6p1PLwxMcIaRa9YayKQzWVFk',
  //  /* domain: 'strider.auth0.com',*/
  //   responseType: 'token id_token',
  //  /* audience: 'https://strider.auth0.com/userinfo',*/
  //   redirectUri: 'http://localhost:8100/callback',
  //   scope: 'openid profile'
  // });

  public loginFalso(): void {
    // let controlTiempo: boolean;
    // let intervalo: any;
    // clearInterval(intervalo);
    // const sub$ = this.ser.pruebaConexionServidor().subscribe((res => {
    //   controlTiempo = true;
    //   this.login(telefono, pass, version, vista);
    //   sub$.unsubscribe();
    // }), (error => {
    //   console.log(error);
    //   sub$.unsubscribe();
    //   this.login(telefono, pass, version, vista);
    // }));

    // intervalo = setTimeout(() => {
    //   if (!controlTiempo) {
    //     sub$.unsubscribe();
    //     this.login(telefono, pass, version, vista);
    //   }
    // }, 2000);
    this.ser.pruebaConexionServidor().toPromise();
  }


  public login(telefono: string, pass: string, version: string, vista: any): void {
    this.controlTiempo = false;
    let controlatiempo: any;
    let mensaje: any;
    const subscripcion = this.ser.getLogin(telefono, pass, version).subscribe((resp: any) => {
      mensaje = resp;
      this.controlTiempo = true;
      // clearInterval(controlatiempo);
      if (vista.loading != null) {
        vista.loading.dismiss();
      }
      switch (mensaje.id) {
        case 3:
          vista.pass = '';
          vista.presentAlertbasico(mensaje.mensaje);
          break;
        case 1:
          localStorage.setItem('id_plataforma', mensaje.id_plataforma);
          localStorage.setItem('empresa_cloud', mensaje.empresa_cloud);
          sessionStorage.setItem('token', mensaje.token);
          this.user = {
            accessToken: Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2),
            idToken: Math.random() * 100000
          };
          vista.pass = '';
          localStorage.removeItem('codigo_empresa');

          if (+resp.codigo_empresa === 1) {
            localStorage.setItem('codigo_empresa', telefono);
          } else {
            localStorage.removeItem('codigo_empresa');
          }

          localStorage.removeItem('telefono');
          localStorage.setItem('telefono', resp.telefono);

          localStorage.removeItem('multi_empresa');
          localStorage.removeItem('empresa_orig');
          if (resp.multi_empresa && resp.multi_empresa.split(',').length > 1) {
            localStorage.setItem('empresa_orig', mensaje.empresa_cloud);
            localStorage.setItem('multi_empresa', resp.multi_empresa);
          }

         /*
          localStorage.removeItem('telefono');
          localStorage.setItem('telefono', telefono);
          */
          this.handleAuthentication();
          break;
        default:
          break;
      }
    }, (error => {
      console.log(error);
      if (vista.loading != null) {
        vista.loading.dismiss();
      }
      subscripcion.unsubscribe();
      vista.presentAlertbasico('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos momentos');
    }));
    // controlatiempo = setTimeout(() => {
    //     if (!this.controlTiempo) {
    //       if (vista.loading != null) {
    //         vista.loading.dismiss();
    //       }
    //       subscripcion.unsubscribe();
    //       vista.presentAlertbasico('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos momentos');
    //     }
    // }, 1000 * 10);
  }

  public handleAuthentication(): void {
    if (this.user && this.user.accessToken && this.user.idToken) {
      this.setSession(this.user);
      this.router.navigate(['/marcaje/0']);
    }
  }

  private setSession(authResult): void {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify((1000 * 60 * 1) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // Go back to the home route
    // this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  public getProfile(cb): void {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('Access token must exist to fetch profile');
    }
  }
  async sigueEnSesion() {
    if (this.isAuthenticated()) {
      await this.ser.setRenuevaSession(localStorage.getItem('telefono'), sessionStorage.getItem('token')).subscribe( (res: any) => {
        if (res.id === 1) {
          const expiresAt = JSON.stringify((1000 * 60 * 5) + new Date().getTime());
          localStorage.setItem('expires_at', expiresAt);
          return true;
        } else {
          this.router.navigate(['/home']);
          return false;
        }
      });
    } else {
      this.router.navigate(['/home']);
      return false;
    }
  }
  public cambiaEmpresa(empresa: number) {
    const multi_empresa = localStorage.getItem('multi_empresa');
    if (multi_empresa) {
      const empresas = multi_empresa.split(',').map(empresa=>Number(empresa));
      if (empresas.length > 0 && empresas.includes(empresa)) {
        localStorage.setItem('empresa_cloud', empresa.toString());
      }
    }
  }
}
